// src/components/notes/EditNote.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext.js';
import './EditNote.css';

export default function EditNote() {
  const { noteId } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');
  const { isAuthenticated } = useAuth();

  const [noteDate, setNoteDate] = useState('');
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  axios.defaults.withCredentials = true;

  useEffect(() => {
    const fetchNote = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/notes/getbynoteid/${noteId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = res.data;
        setNoteDate(data.noteDate.slice(0, 10));
        setContent(data.content);
      } catch (err) {
        console.error(err);
        setError('Fout bij laden notitie');
      } finally {
        setIsLoading(false);
      }
    };

    fetchNote();
  }, [noteId, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/notes/update/${noteId}`,
        { noteDate, content },
        {
          headers: {
            Authorization: `Bearer ${token}`          },
        }
      );
      navigate(-1);
    } catch (err) {
      console.error(err);
      setError('Fout bij bijwerken notitie');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isAuthenticated) return <p>Niet ingelogd.</p>;
  if (isLoading) return <p>Loading...</p>;

  return (
    <div className="edit-note-container">
      <h2>Bewerk Notitie</h2>
      <form onSubmit={handleSubmit} className="edit-note-form">
        <label>
          Datum:
          <input
            type="date"
            value={noteDate}
            onChange={(e) => setNoteDate(e.target.value)}
            required
          />
        </label>

        <label>
          Notitie:
          <textarea
            rows="6"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
          />
        </label>

        {error && <p className="error-message">{error}</p>}

        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate(-1)}
            disabled={isSubmitting}
          >
            Annuleren
          </button>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Opslaan...' : 'Opslaan'}
          </button>
        </div>
      </form>
    </div>
  );
}